import styled from 'styled-components'

export const AudioOff = styled.img`
    border-radius: 50%;
    max-width: 100%;
    max-height: 100%;
`
